import { v4 as uuidv4 } from "uuid";
export class SecurityUserModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.email = "";
        this.roleType = "ClientAppUser";
        this.dateOfBirth = null;
        this.OutputDateOfBirthInString = "";
        this.inputDateOfBirthInString = "";
        this.profileImageUrl = "";
        this.dateFormat = "";
        this.timeZone = "";
    }
}
export default class SecurityUser extends SecurityUserModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
